import { z } from "zod";

export const courtLevelSchema = z.object({
	id: z.string().optional(),
	name: z.string(),
	code: z.string(),
	description: z.string().optional(),
	status: z.string().optional(),
	created_at: z.string().optional(),
	udpated_at: z.string().optional(),
});

export type CourtLevel = z.infer<typeof courtLevelSchema>;
